export const updateFavicon = () => {
  const favicon = document.getElementById('favicon') as HTMLLinkElement;
  if (favicon) {
    favicon.href = '/app-icon.svg';
  }
};

export const setTheme = (theme: 'light' | 'dark') => {
  localStorage.setItem('theme', theme);
  if (theme === 'dark') {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
  updateFavicon();
};

export const toggleTheme = () => {
  const current = localStorage.getItem('theme') === 'dark' ? 'dark' : 'light';
  const next = current === 'dark' ? 'light' : 'dark';
  setTheme(next);
  return next;
};

export const getTheme = (): 'light' | 'dark' => {
  return localStorage.getItem('theme') === 'dark' ? 'dark' : 'light';
};
